module.exports = __webpack_public_path__ + "img/address_list.0a5aebfc.svg";